// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/marketing/notification/v1/notification.proto (package stailer_service_specification.marketing.notification.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/marketing/notification/v1/notification.proto.
 */
const file_stailer_service_specification_marketing_notification_v1_notification = /*@__PURE__*/
  fileDesc("CkpzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tYXJrZXRpbmcvbm90aWZpY2F0aW9uL3YxL25vdGlmaWNhdGlvbi5wcm90bxI3c3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24ubWFya2V0aW5nLm5vdGlmaWNhdGlvbi52MSKFAgoMTm90aWZpY2F0aW9uEvQBCiFlbmFibGVfc2VuZF9hbm5vdW5jZW1lbnRfdG9fZ3Vlc3QYASABKAhCyAGSghmaAeOCsuOCueODiOOBq+WvvuOBl+OBpuOBiuefpeOCieOBm+OBrlB1c2jpgJrnn6XjgpLpgIHkv6HjgZnjgovjgYvjganjgYbjgYvjgpLmjIflrprjgZfjgb7jgZnjgILjg6bjg7zjgrbjg7zjgbjjga7jgYrnn6XjgonjgZvjga/luLjjgavpgIHkv6HjgZXjgozjgb7jgZnjgIKqghkh44Ky44K544OI44G444Gu44GK55+l44KJ44Gb6YCa55+lyIIZAWIGcHJvdG8z", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.marketing.notification.v1.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
const NotificationSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_notification_v1_notification, 0);


exports.file_stailer_service_specification_marketing_notification_v1_notification = file_stailer_service_specification_marketing_notification_v1_notification;
exports.NotificationSchema = NotificationSchema;
